import React from 'react';
import { IProps } from './type';

const AccountIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_13455_208470)">
        <path
          d="M19.9774 20.4471C19.5216 19.1713 18.5172 18.0439 17.1201 17.2399C15.7229 16.4358 14.0111 16 12.25 16C10.4889 16 8.77706 16.4358 7.37991 17.2399C5.98276 18.0439 4.97839 19.1713 4.52259 20.4471"
          stroke={strokeColor ? strokeColor : "#212121"}
          strokeLinecap="round" />
        <circle cx="12.25" cy="8" r="4"
          stroke={strokeColor ? strokeColor : "#212121"}
          strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_13455_208470">
          <rect
            width={width ? width : '24'}
            height={height ? height : '24'}
            fill={fillColor ? fillColor : 'white'}
            transform="translate(0.25)" />
        </clipPath>
      </defs>
    </svg>
  )
};

export default AccountIcon;
